export default __webpack_public_path__ + "static/media/caso_5_1.1c15a94b.jpg";